<template>
    <div id="bodybox">
        <header-nav :cur="6" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="questiontwo" @click="toback()">问答</span>
                    >
                    <span class="infor">问答详情</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">为您解答</div>
                        <div class="newbot">汇集知识碎片，解决学习难题</div>
                    </div>
                    <!-- <div class="input">
                        <img src="../../assets/img/question/icon_questions.svg" alt="" />
                        <div class="select" @click="showPopup">我要提问</div>
                    </div> -->
                </div>
            </div>
        </div>
     
        <!-- 问答 -->
        <div class="navtab">
            <!-- 问答 -->
            <div class="quest">
                <div class="title">
                    <img src="../../assets/img/question/wenda_icon.svg" alt="" />
                    问答
                </div>
                <div class="name">
                    <img src="../../assets/img/index/course.jpg" alt="" />
                    文文跑江湖
                </div>
                <div class="content">
					{{form_content}}
                </div>
                <div class="time">时间：2021-05-21</div>
                <div class="eval">
                    <img src="../../assets/img/index/course.jpg" alt="" />
                    <div class="rela">
                        <textarea v-model="content"  cols="30" rows="10" maxlength="2000" placeholder="请不要发布非法言论，给出您最中肯的意见"></textarea>
                        <div class="num">0/2000</div>
                    </div>
                </div>
                <div class="reset" @click="submitReplay">提交评论</div>
            </div>
            <!-- 评价 -->
            <div>
                <div class="appra">
                    <img src="../../assets/img/question/icon_discuss.svg" alt="" />
                    评论
                    <span>（{{total}}条）</span>
                </div>
                <div class="con"  v-for="(item, index) in hf_ist" :key="index">
                    <div class="name">
                        <img src="../../assets/img/index/course.jpg" alt="" />
                        {{item.userName}}
                    </div>
                    <div class="timebox">
                        <div class="content">
                            {{item.content}}
                        </div>
                        <div class="time">评论时间：{{item.createTime}}</div>
                    </div>
                </div>
            </div>
        </div>
		
		<div class="paging">
		    <div @click="queryQuestionDetailList(1)">首页</div>
		    <div @click="queryQuestionDetailList(pageNum-1)" v-if="pageNum>1">上一页</div>
		    <div>{{pageNum}}/{{pageCount}}</div>
		    <div @click="queryQuestionDetailList(pageNum+1)" v-if="pageNum<pageCount">下一页</div>
		    <div @click="queryQuestionDetailList(pageCount)">末页</div>
		</div>
		
		<!-- 我要提问 -->
		<van-popup v-model="show" closeable>
		    <div class="showbox">
		        <div class="head">
		            <img src="../../assets/img/index/course.jpg" alt="" />
		            <div>
		                <div class="top">文文跑江湖</div>
		                <div class="bot">我要提问</div>
		            </div>
		        </div>
		        <div class="textame">
		            <textarea name="" id="" maxlength="2000" placeholder="在学习的过程中有任何疑问都可以在这里提问......"></textarea>
		            <div class="num">0/2000</div>
		        </div>
		        <div class="reset">提交</div>
		    </div>
		</van-popup>
		

        <footer-nav />
    </div>
</template>
<script>
import Vue from 'vue';
import { Popup } from 'vant';

Vue.use(Popup);
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
		
    },
    data() {
        return {
            show: false,
			id:'',
			total:0,
			pageCount:1,
			pageSize:15,
			pageNum:1,	
			hf_ist:[],
			content:'',
			form_content:'',
			loginstate:false,
			token:'',
			user:''
        };
    },
	created() {
		this.id = this.$route.query.id;
		this.queryFormInfo(this.id);
		this.queryQuestionDetailList(1);
	},
	mounted() {
		this.confirmUser();
	},
    methods: {
		confirmUser(){
			this.token = localStorage.getItem('token');
			if(this.token == null || this.token ==''){
				this.loginstate = false;
				//this.$router.push('/login');
			}else{
			    this.queryLoginState();
		    }
		},
		queryLoginState(){
			this.token = localStorage.getItem('token');
			this.$http.get(this.$api.url +'/papi/user/queryLoginState',
			        {params:{'token':this.token}}).then((response) => {
			        var obj = response.data;
			        if(obj.code == 500){
						this.loginstate=false;
						//this.$router.push('/login');
						return;
					}
					if(obj.code == 200){
						this.loginstate=true;
						this.user = response.data.data.user;
					}
					console.log(obj);
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		queryFormInfo(id){
			this.$http.get(this.$api.url +'/papi/forum/queryFormById',
			   {params:{wid:this.id}}).then((response) => {	   
			   this.form_content = response.data.data.content;
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		submitReplay(){	
			if(this.loginstate==false){
				this.$router.push('/login');
				return;
			}
			if(this.content == null || this.content==''){
				alert('请填写回复内容');
				return;
			}
			this.$http.get(this.$api.url +'/papi/forum_reply/add',
			   {params:{forumId:this.id,'content':this.content}}).then((response) => {
			   alert('提交成功');
			   this.content='';
			   this.queryQuestionDetailList(1);
			}, (response) => {
			    console.log("response"+response.data.rows.length);
			});
		},
		queryQuestionDetailList(pageNum){
		    this.$http.get(this.$api.url +'/papi/forum_reply/list',{params:{'forumId':this.id}}).then((response) => {
				this.hf_ist=[];
				this.pageNum = pageNum;
				this.hf_ist = response.data.rows;	
				this.total = response.data.total;
				if((this.total%this.pageSize)>0){
					this.pageCount = parseInt(this.total/this.pageSize)+1;
				}else{
					this.pageCount = this.total%this.pageSize;
				}
		    }, (response) => {
			    console.log("response"+response.data.rows.length);
		    });
		},
        showPopup() {
            this.show = true;
        },
        toback() {
            this.$router.back(-1);
        },
    },
};
</script>
<style lang="less" scoped>
   // 公共
   .navtab {
       width: 1280px;
       margin: 0 auto;
   }
   .color {
       color: #2961EF !important;
   }
   .ignore {
       overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-box-orient: vertical;
       -webkit-line-clamp: 3;
   }
   // 搜索
   .nav {
       background: #f7f8fa;
       width: 100%;
       height: 177px;
       .top {
           display: block;
           font-size: 16px;
           font-weight: 300;
           color: #777777;
           padding: 19px 0 24px;
           .questiontwo {
               cursor: pointer;
           }
           .infor {
               color: #2961EF;
           }
       }
       .newbox {
           display: flex;
           justify-content: space-between;
           align-items: center;
           .newtop {
               font-size: 26px;
               color: #000000;
               margin-bottom: 5px;
           }
           .newbot {
               font-size: 16px;
               color: #888888;
           }
           .input {
               background: #2961EF;
               border-radius: 30px;
               width: 149px;
               height: 47px;
               display: flex;
               align-items: center;
               img {
                   margin-left: 10px;
                   margin-right: 20px;
               }
               .select {
                   font-size: 16px;
                   color: #ffffff;
                   background: none;
                   text-align: center;
               }
           }
       }
   }
   // 问答
   .quest {
       margin-top: 26px;
       position: relative;
       .title {
           img {
               vertical-align: middle;
               margin-right: 7px;
               // margin-bottom: 17px;
           }
           font-weight: 300;
           font-size: 18px;
           color: #777777;
       }
       .name {
           font-size: 16px;
           font-weight: 600;
           color: #777777;
           margin-top: 20px;
           img {
               width: 44px;
               height: 44px;
               border-radius: 50%;
               margin-right: 14px;
               vertical-align: middle;
           }
       }
       .content {
           padding: 8px 27px;
           font-size: 16px;
           color: #333333;
           text-indent: 2em;
       }
       .time {
           font-size: 14px;
           color: #999999;
       }
       .eval {
           padding: 40px 0 48px 58px;
           img {
               width: 44px;
               height: 44px;
               border-radius: 50%;
               margin-right: 14px;
               vertical-align: top;
           }
           .rela {
               margin-bottom: 26px;
               display: inline-block;
               position: relative;
               width: 94%;
               textarea {
                   width: 97%;
                   border: 1px solid #e9e8f1;
                   height: 123px;
                   background: #f7f8fa;
                   border-radius: 5px 5px 5px 5px;
                   padding: 11px 22px;
                   &::placeholder {
                       font-size: 16px;
                       color: #999999;
                   }
               }
               .num {
                   font-size: 16px;
                   color: #999999;
                   position: absolute;
                   bottom: 14px;
                   right: 14px;
                   z-index: 1000;
               }
           }
       }
       .reset {
           width: 178px;
           height: 45px;
           line-height: 45px;
           text-align: center;
           background: #2961EF;
           border-radius: 29px 29px 29px 29px;
           font-size: 16px;
           color: #ffffff;
           position: absolute;
           bottom: 0;
           right: 0;
           margin: 36px 0 0;
       }
   }
   // 评价
   .appra {
       border-bottom: 1px solid rgba(112, 112, 112, 0.14);
       font-size: 18px;
       color: #333333;
       padding-bottom: 20px;
       img {
           vertical-align: middle;
       }
       span {
           color: #2961EF;
       }
   }
   .con {
       .name {
           font-size: 16px;
           font-weight: 600;
           color: #777777;
           margin-top: 20px;
           img {
               width: 44px;
               height: 44px;
               border-radius: 50%;
               margin-right: 14px;
               vertical-align: middle;
           }
       }
       .timebox {
           border-bottom: 1px dashed rgba(112, 112, 112, 0.25);
           margin-left: 60px;
           .content {
               padding: 8px 27px 8px 0;
               font-size: 16px;
               color: #333333;
           }
           .time {
               font-size: 14px;
               color: #999999;
               margin-bottom: 32px;
           }
       }
   }
   
   // 我要提问
   .van-popup {
       padding: 45px 32px;
       background: #ffffff;
       border-radius: 5px 5px 5px 5px;
       .head {
           display: flex;
           align-items: center;
           img {
               width: 63px;
               height: 63px;
               border-radius: 50%;
               margin-right: 15px;
           }
           .top {
               font-size: 16px;
               color: #000000;
           }
           .bot {
               font-size: 18px;
               font-weight: 600;
               color: #f17719;
           }
       }
       .textame {
           position: relative;
           margin-top: 29px;
           margin-bottom: 33px;
           textarea {
               font-size: 16px;
               color: #999999;
               padding: 17px 23px;
               background: #f7f8fa;
               width: 663px;
               height: 161px;
               border: 1px solid #e9e8f1;
               &::placeholder {
                   font-size: 16px;
                   color: #999999;
               }
           }
           .num {
               position: absolute;
               bottom: 9px;
               right: 19px;
               font-size: 16px;
               color: #999999;
           }
       }
       .reset {
           width: 148px;
           height: 45px;
           line-height: 45px;
           text-align: center;
           background: #2961EF;
           border-radius: 10px 10px 10px 10px;
           font-size: 16px;
           color: #ffffff;
           float: right;
       }
   }
   // 分页
   .paging {
       width: 534px;
       height: 50px;
       background: rgba(112, 112, 112, 0.18);
       border-radius: 37px 37px 37px 37px;
       margin: 35px auto;
       display: flex;
       align-items: center;
       font-size: 16px;
       color: #888888;
       justify-content: space-around;
       text-align: center;
       div {
           height: 50px;
           line-height: 50px;
           border-right: 1px solid rgba(112, 112, 112, 0.2);
           width: 20%;
           &:nth-child(5) {
               border: none;
           }
       }
   }
   
</style>